//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 02.03.2016.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .provider('extensionService', extensionServiceProvider);

    function extensionServiceProvider() {

        var extensions = [];
        var allExtensions = [];

        this.addExtension = function (label, abbreviation, icon, authIdent) {
            // Device monitoring should be enabled only if we have 'DevMonOperatorRole', 'DevMonRuleAdminRole', 'DevMonRexAdminRole' or 'Superuser' role
            if (abbreviation === 'em') {
                const devmonAllowedRolesList = ['DevMonOperatorRole', 'DevMonRuleAdminRole', 'DevMonRexAdminRole', 'Superuser'];
                const data = window._keycloak.tokenParsed.realm_access.roles.find((role) => devmonAllowedRolesList.includes(role));
                if (!data) return;
            }
            var extension = new Extension(label, abbreviation, icon, authIdent);
            extensions.push(extension);
            allExtensions.push(extension);
        };

        this.$get = function extensionService($rootScope, $q, headerService, navigationService, Authorization, localStorageService, Event) {

            var service = {};

            init();
            function init() {
                extensions = allExtensions.slice();
                allExtensions.forEach(ext => {
                    if (ext.authIdent !== undefined) {
                        console.log("authIdent found: ", ext.authIdent);
                        authorizeActivityAllow(ext.authIdent)
                            .then(authorized => {
                                // this is intentional override 
                            }
                                ,
                                unauthorized => {
                                    _.remove(extensions, e => e.authIdent == ext.authIdent);
                                })
                    }
                });
                $rootScope.$on(Event.USER_LOGGED_IN, function () { init(); });
            }

            service.getExtensions = function () {
                return extensions;
            };

            service.getExtension = function (abbreviation) {
                return _.find(extensions, function (extension) { return extension.abbreviation == abbreviation; });
            };

            service.getActiveExtension = function () {
                return extensions[0];
            };

            service.setActiveExtension = function (abbreviation) {

                headerService.removeComponents();
                navigationService.removeStates();

                if (localStorageService.get("currentView") != abbreviation && abbreviation != 'container') {
                    localStorageService.set(localStorageService.get("currentView") + "Path", window.location.href);
                }
                localStorageService.set("currentView", abbreviation);

                var extension = service.getExtension(abbreviation);

                extensions.unshift(extensions.splice(extensions.indexOf(extension), 1)[0]);

                $rootScope.$emit('extensionService:activeExtensionChanged', { 'extension': extension });
            };

            service.setActiveExtension('container');

            function authorizeActivityAllow(ident) {
                var deferred = $q.defer();
                console.log("authorizing extension: ", ident);

                Authorization.isAuthorizedActivity({ ident: encodeURI(ident) }, function (authorized) {
                    if (authorized.allowed) {
                        console.log("container init service authorized activity! ", authorized);
                        deferred.resolve();
                    } else {
                        console.log("container init service unauthorized: ", authorized);
                        deferred.reject('unauthorized');
                    }
                }, function (error) {
                    console.log("error during authorization of extension: ", ident, error);
                    $rootScope.$emit('displayError', 'notification.displayError', error);
                    deferred.reject(error);
                });

                $rootScope.$emit('handleBusyPromise', deferred.promise);
                return deferred.promise;
            }

            function authorizeActivitiesAllow(idents) {
                var deferred = $q.defer();

                Authorization.areAuthorizedActivities({ ident: idents }, function (response) {
                    console.log("container init service authorization response: ", response);
                    deferred.resolve(response);
                }, function (error) {
                    $rootScope.$emit('displayError', 'notification.displayError', error);
                    deferred.reject(error);
                });

                $rootScope.$emit('handleBusyPromise', deferred.promise);
                return deferred.promise;
            }

            return service;
        }
    }

    function Extension(label, abbreviation, icon, authIdent) {
        this.label = label;
        this.abbreviation = abbreviation;
        this.icon = icon;
        this.authIdent = authIdent
    }
})();